import { useState } from 'react';
import type { ReportFormValues } from '../validation/report';
import { submitIncidentReport } from '../services/incidentReport';

export function useReportForm() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const handleSubmit = async (values: ReportFormValues) => {
    setSubmitting(true);
    setError(null);
    try {
      await submitIncidentReport(values);
      setSubmitted(true);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setSubmitting(false);
    }
  };

  const handleReset = () => {
    setSubmitted(false);
    setSubmitting(false);
    setError(null);
  };

  return { submitted, submitting, error, handleSubmit, handleReset };
}
